export default __webpack_public_path__ + "static/media/bg_qr_border.3a9e9e28.svg";